import React, { useCallback, useState } from 'react';
import { routes } from 'appConstants';
import { ButtonV4, Link } from 'components';
import { _t } from 'utils';

import topBanner from 'assets/img/main-v4/hero-curve.png';
import iconPlus from 'assets/img/vacancies-v4/icon-plus.svg';

import {
  DEPARTMENTS,
  INTRO_SIDE,
  INTRO_TEXT_LEAD,
  INTRO_TEXT_REST,
  INTRO_TITLE,
  SEE_ALSO,
  VACANCIES,
  Vacancy,
} from './data';
import VacancyDetail from './VacancyDetail';
import ResumeForm from './ResumeForm';
import styles from './styles.module.scss';

const Vacancies = () => {
  const [detail, setDetail] = useState<Vacancy | null>(null);
  const [resumeOpen, setResumeOpen] = useState(false);
  const [resumeVacancyTitle, setResumeVacancyTitle] = useState('');

  const openResume = useCallback(() => {
    setDetail(null);
    setResumeVacancyTitle('');
    setResumeOpen(true);
  }, []);

  const openDetail = useCallback((item: Vacancy) => {
    setResumeOpen(false);
    setDetail(item);
  }, []);

  const closeDetail = useCallback(() => setDetail(null), []);
  const closeResume = useCallback(() => {
    setResumeOpen(false);
    setResumeVacancyTitle('');
  }, []);

  const handleApplyFromDetail = useCallback(() => {
    setResumeVacancyTitle(detail?.cardTitle || '');
    setDetail(null);
    setResumeOpen(true);
  }, [detail]);

  return (
    <div className={styles.page}>
      <div className={styles.banner} aria-hidden>
        <img src={topBanner} alt="" />
      </div>

      <section className={styles.head}>
        <h1 className={styles.title}>{_t('Вакансии')}</h1>
        <nav className={styles.crumbs} aria-label={_t('Навигация')}>
          <Link to={routes.main.root} className={styles.crumbLink}>
            {_t('Главная')}
          </Link>
          <span className={styles.crumbLine} aria-hidden />
          <span className={styles.crumbCurrent}>{_t('Вакансии')}</span>
        </nav>
      </section>

      <section className={styles.introRow}>
        <div className={styles.intro}>
          <h2 className={styles.introTitle}>{_t(INTRO_TITLE)}</h2>
          <p className={styles.introText}>
            <strong className={styles.introLead}>{_t(INTRO_TEXT_LEAD)}</strong>
            {_t(INTRO_TEXT_REST)}
          </p>
          <ButtonV4
            label="Отправить резюме"
            variant="outline"
            tone="onLight"
            iconSrc={iconPlus}
            onClick={openResume}
          />
        </div>
        <div className={styles.introSide}>
          <img src={INTRO_SIDE} alt="" />
        </div>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{_t('Актуальные вакансии')}</h2>
        <ul className={styles.vacancyList}>
          {VACANCIES.map((item) => (
            <li key={item.id} className={styles.vacancyItem}>
              <img src={item.photo} alt="" className={styles.vacancyPhoto} />
              <div className={styles.vacancyBody}>
                <h3 className={styles.vacancyTitle}>{_t(item.cardTitle)}</h3>
                <ButtonV4
                  className={styles.vacancyBtn}
                  label="Подробное описание"
                  variant="outline"
                  tone="onLight"
                  onClick={() => openDetail(item)}
                />
              </div>
            </li>
          ))}
        </ul>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{_t('Наши управления')}</h2>
        <ul className={styles.departmentsGrid}>
          {DEPARTMENTS.map((item) => (
            <li
              key={item.id}
              className={styles.department}
              style={{ backgroundImage: `url(${item.photo})` }}
            >
              <div className={styles.departmentTitle}>{_t(item.title)}</div>
            </li>
          ))}
        </ul>
      </section>

      <section className={styles.seeAlso}>
        <h2 className={styles.seeTitle}>{_t('Смотрите также')}</h2>
        <ul className={styles.seeGrid}>
          {SEE_ALSO.map((item) => (
            <li
              key={item.id}
              className={styles.seeCard}
              style={{ backgroundImage: `url(${item.image})` }}
            >
              <div className={styles.seeCardTitle}>{_t(item.title)}</div>
              <ButtonV4
                to={item.to}
                label="Перейти в раздел"
                variant="solid"
                tone="onLight"
              />
            </li>
          ))}
        </ul>
      </section>

      {detail && (
        <VacancyDetail
          vacancy={detail}
          onClose={closeDetail}
          onApply={handleApplyFromDetail}
        />
      )}
      {resumeOpen && (
        <ResumeForm onClose={closeResume} vacancyTitle={resumeVacancyTitle} />
      )}
    </div>
  );
};

export default Vacancies;
